import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { TherapyAttribute } from '@repo/types/src/glow-up';
import { DeleteTherapyAttribute } from './DeleteTherapyAttribute';
import { EditTherapyAttribute } from './EditTherapyAttribute';

type TherapyAttributeCardProps = {
  attribute: TherapyAttribute;
  refetch: () => void;
};

const getStatusVariant = (status: string) =>
  status === 'active' ? 'default' : 'secondary';

const getStatusLabel = (status: string) =>
  status === 'active' ? 'Actif' : 'Inactif';

export const TherapyAttributeCard = ({
  attribute,
  refetch,
}: TherapyAttributeCardProps) => {
  return (
    <Card className="p-4 w-72 flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <h3 className="font-semibold text-lg">{attribute.name}</h3>
        <Badge variant={getStatusVariant(attribute.status)}>
          {getStatusLabel(attribute.status)}
        </Badge>
      </div>

      <div className="flex gap-2 mt-auto">
        <EditTherapyAttribute attribute={attribute} refetch={refetch} />
        <DeleteTherapyAttribute attribute={attribute} refetch={refetch} />
      </div>
    </Card>
  );
};
